function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["variants"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { createRenderer } from 'fela';
import plugins from 'fela-preset-web';
import responsiveValue from 'fela-plugin-responsive-value';
import themeValue from 'fela-plugin-theme-value';
import sortMediaQueryMobileFirst from 'fela-sort-media-query-mobile-first';
import enforceLonghands from 'fela-enforce-longhands';
import customProperty from 'fela-plugin-custom-property';
import namedKeys from 'fela-plugin-named-keys';
import multipleSelectors from 'fela-plugin-multiple-selectors';
import hoverMedia from 'fela-plugin-hover-media';
import isPlainObject from 'isobject';
import staticStyle from './staticStyle.js';
import * as customProperties from './customProperties.js';
export var responsiveProps = {
  backgroundColor: true,
  padding: true,
  paddingLeft: true,
  paddingRight: true,
  paddingBottom: true,
  paddingTop: true,
  margin: true,
  marginLeft: true,
  marginRight: true,
  marginBottom: true,
  marginTop: true,
  width: true,
  height: true,
  minWidth: true,
  minHeight: true,
  maxWidth: true,
  maxHeight: true,
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  alignSelf: true,
  alignItems: true,
  alignContent: true,
  justifyContent: true,
  flexDirection: true,
  flexWrap: true,
  order: true,
  display: true,
  color: true,
  textAlign: true,
  textTransform: true,
  scrollPadding: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridGap: true,
  columnGap: true,
  // custom typography properties
  typographyVariant: true,
  typographySubStyle: true
};
var themeValueMapping = {
  color: function color(theme) {
    return theme.colors;
  },
  background: function background(theme) {
    return theme.colors;
  },
  backgroundColor: function backgroundColor(theme) {
    return theme.colors;
  },
  borderColor: function borderColor(theme) {
    return theme.colors;
  },
  borderTopColor: function borderTopColor(theme) {
    return theme.colors;
  },
  borderBottomColor: function borderBottomColor(theme) {
    return theme.colors;
  },
  borderLeftColor: function borderLeftColor(theme) {
    return theme.colors;
  },
  borderRightColor: function borderRightColor(theme) {
    return theme.colors;
  },
  textDecorationColor: function textDecorationColor(theme) {
    return theme.colors;
  },
  stroke: function stroke(theme) {
    return theme.colors;
  },
  fill: function fill(theme) {
    return theme.colors;
  },
  '--icon-color': function iconColor(theme) {
    return theme.colors;
  }
};
var getResponsiveMediaQueries = function getResponsiveMediaQueries(values, props) {
  var _props$theme$breakpoi = props.theme.breakpoints,
    small = _props$theme$breakpoi.small,
    medium = _props$theme$breakpoi.medium,
    large = _props$theme$breakpoi.large,
    huge = _props$theme$breakpoi.huge;
  var mediaQueryMap = {
    1: [],
    2: [small],
    3: [small, medium],
    4: [small, medium, large],
    5: [small, medium, large, huge]
  };
  return mediaQueryMap[values.length];
};
function resolveTypography(style, theme) {
  for (var property in style) {
    var value = style[property];
    if (isPlainObject(value)) {
      style[property] = resolveTypography(value, theme);
    }
  }
  var typographyVariant = style.typographyVariant,
    typographySubStyle = style.typographySubStyle;
  if (typographyVariant) {
    var _theme$typography$typ = theme.typography[typographyVariant],
      _theme$typography$typ2 = _theme$typography$typ.variants,
      variants = _theme$typography$typ2 === void 0 ? {} : _theme$typography$typ2,
      typographyStyle = _objectWithoutProperties(_theme$typography$typ, _excluded);
    var variantStyle = typographySubStyle && variants[typographySubStyle] || {};

    // remove custom properties
    delete style.typographyVariant;
    delete style.typographySubStyle;
    return Object.assign(_objectSpread(_objectSpread({}, typographyStyle), variantStyle), style);
  }
  return style;
}
function typographyPlugin(style, type, renderer, props) {
  return resolveTypography(style, props.theme);
}
var _plugins = _slicedToArray(plugins, 5),
  extend = _plugins[0],
  embedded = _plugins[1],
  unit = _plugins[2],
  fallbackValue = _plugins[3],
  prefixer = _plugins[4];
export default function getStyleRenderer() {
  var renderer = createRenderer({
    filterClassName: function filterClassName(className) {
      return !['fc'].includes(className);
    },
    enhancers: [sortMediaQueryMobileFirst(), enforceLonghands()],
    plugins: [namedKeys(function (props) {
      var _props$theme;
      return (props === null || props === void 0 || (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.breakpoints) || {};
    }), hoverMedia(), multipleSelectors(), extend, embedded, customProperty({
      marginHorizontal: customProperties.marginHorizontal,
      marginVertical: customProperties.marginVertical,
      paddingHorizontal: customProperties.paddingHorizontal,
      paddingVertical: customProperties.paddingVertical
    }), responsiveValue(getResponsiveMediaQueries, responsiveProps), themeValue(themeValueMapping), typographyPlugin, unit, fallbackValue, prefixer]
  });
  staticStyle.forEach(function (rule) {
    return renderer.renderStatic(rule.style, rule.selector);
  });

  // TODO: lazy render on use
  renderer.renderFont('Pangea', ['/fonts/pangea/Pangea-Regular.woff2'], {
    fontDisplay: 'swap'
  });
  renderer.renderFont('Pangea', ['/fonts/pangea/Pangea-Medium.woff2'], {
    fontWeight: 500,
    fontDisplay: 'swap'
  });
  renderer.renderFont('Pangea', ['/fonts/pangea/Pangea-SemiBold.woff2'], {
    fontWeight: 600,
    fontDisplay: 'swap'
  });
  renderer.renderFont('Pangea Text', ['/fonts/pangea/PangeaText-Regular.woff2'], {
    fontDisplay: 'swap'
  });
  renderer.renderFont('Pangea Text', ['/fonts/pangea/PangeaText-Medium.woff2'], {
    fontWeight: 500,
    fontDisplay: 'swap'
  });
  renderer.renderFont('Pangea Text', ['/fonts/pangea/PangeaText-SemiBold.woff2'], {
    fontWeight: 600,
    fontDisplay: 'swap'
  });
  return renderer;
}